/**
 * CSS Prefix
 * MUST be in sync with CSS_PREFIX inside ./constants.ts for client side
 */
export const CSS_PREFIX = 'ftbl__';
